var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$route.meta.component,{tag:"component",attrs:{"facility":_vm.facility,"facilityId":_vm.facilityId,"reportTypes":_vm.reportTypes,"reportSubscriptionId":_vm.reportSubscriptionId}})
}
var staticRenderFns = []

export { render, staticRenderFns }